import React from "react";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default function NumberDecimalMask(props) {
  const { inputRef, ...other } = props;
  const numberMask = createNumberMask({
    prefix: "",
    suffix: "",
    includeThousandsSeparator: false,
    integerLimit: 10,
    decimalSymbol: '.',
    allowDecimal: true,
    decimalLimit: 1,
  });
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={numberMask}
      keepCharPositions={false}
    />
  );
}
